import { API_ROOT } from './.env'

export const login =  '/login'

export const register =  '/register'

export const passwordEmail = API_ROOT + 'password/email'

export default {
    login,
    register,
    passwordEmail
}



// WEBPACK FOOTER //
// ./src/api/guest.js